'use strict'

// One cell display for a table, cards, calendar, and map popup.
// A choice list is shown as that list. Number and text formatting do not
// rewrite it. Text style still wraps the list. Other values use value formatting.

const { formatMultiselectDisplay, formatMultiselectHtml, readMultiselectItems } = require('./multiselect-display')
const { fieldDisplayHtml, formatFieldDisplay, htmlWithTextStyle } = require('./value-format')

// A stored instant is shown as a date before text formatting is applied,
// so bold or a replacement changes "Oct 6, 2026, 3:09 PM", not the raw timestamp.
function fieldDisplayValue (raw, display) {

  if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(raw) && display != null && display !== '') {

    return display
  }

  return raw != null ? raw : display
}

function shownField (value, options) {

  const settings = options || {}
  const items = readMultiselectItems(value)

  if (items) {

    const formatting = settings.valueFormatting
    const style = formatting && formatting.type === 'text' ? formatting : null

    return {
      text: formatMultiselectDisplay(value, settings.multiselectDisplay),
      html: htmlWithTextStyle(formatMultiselectHtml(value, settings.multiselectDisplay), style),
      list: true
    }
  }

  const display = formatFieldDisplay(value, settings.valueFormatting)

  if (!display) return null

  return {
    text: display.text,
    html: fieldDisplayHtml(value, settings.valueFormatting),
    list: false
  }
}

module.exports = { shownField, fieldDisplayValue }
